const TOIMENPIDE_CATEGORIES = {
  "Ei kategoriaa": [
    "Ei aliluokkaa"
  ],  
  "Rakennetekniikka": [
    "Ei aliluokkaa",
    "Vierustat ja kuivatusosat",
    "Pihapäällysteet",
    "Aluevarusteet ja -rakenteet",
    "Perustukset ja sokkelit",
    "Alapohja",
    "Rakennusrunko",
    "Ulkoseinät",
    "Ikkunat",
    "Ulko-ovet",
    "Parvekkeet",
    "Kattorakenteet",
    "Sisätilat",
    "Märkätilat"
  ],
  "LVI-järjestelmät": [
    "Ei aliluokkaa",
    "Lämmöntuotanto",
    "Lämmitysverkosto",
    "Vesijohtoverkosto",
    "Viemäriverkosto",
    "Ilmanvaihtojärjestelmä",
    "Jäähdytysjärjestelmät",
    "Rakennusautomaatio",
    "Muut järjestelmät"
  ],
  "Sähköjärjestelmät": [
    "Ei aliluokkaa",
    "Aluesähköistys",
    "Kytkinlaitokset ja jakokeskukset",
    "Johdot ja niiden varusteet",
    "Valaisimet, lämmittimet, kojeet ja laitteet",
    "Tele- ja antennijärjestelmät",
    "Palo- ja turvajärjestelmät",
    "Siirtolaitteet"
  ],
  "Lisätutkimukset": [
    "Ei aliluokkaa",
  ]
};

const TOIMENPIDE_NORMALIZATION = {
  rakenne: "Rakennetekniikka",
  lvi: "LVI-järjestelmät",
  sahko: "Sähköjärjestelmät",
};

function normalizeToimenpide(cat) {
  return TOIMENPIDE_NORMALIZATION[cat] || cat || "";
}

module.exports = { TOIMENPIDE_CATEGORIES, TOIMENPIDE_NORMALIZATION, normalizeToimenpide };
